// extracted by mini-css-extract-plugin
export default {"MainCont":"Mixing_MainCont__AM7mY","RightCont":"Mixing_RightCont__4IMP2"};